module.exports = {
  changeChargeNo: 'หมายเลขลำดับการขอ',
  changeReason: 'เหตุผลการเปลี่ยนแปลง',
  state: 'ความคืบหน้าของการขอ',
  jobNo: 'เลขที่ธุรกิจ',
  customerId: 'หน่วยงานที่มอบหมาย',
  receivable: 'ประเภทค่าใช้จ่าย',
  dateCreated: 'เวลาที่ขอ',
  createdBy: 'ผู้ขอ',
  judgeDutyResult: 'ผลการตรวจสอบความรับผิดชอบ',
  judgeDutyDate: 'เวลาตรวจสอบความรับผิดชอบ',
  judgeDutyBy: 'ผู้ตรวจสอบความรับผิดชอบ',
  businessAuditResult: 'ผลการตรวจสอบทางธุรกิจ',
  businessAuditReason: 'เหตุผลการปฏิเสธ',
  businessAuditDate: 'เวลาตรวจสอบทางธุรกิจ',
  businessAuditBy: 'ผู้ตรวจสอบทางธุรกิจ',
  judgeClosedResult: 'ตัดสินปิดบัญชี',
  judgeClosedDate: 'เวลาตัดสินปิดบัญชี',
  judgeClosedBy: 'ผู้ตัดสินปิดบัญชี',
  returnReason: 'เหตุผลการส่งคืน',
  returnDate: 'เวลาส่งคืน',
  returnBy: 'ผู้ส่งคืน',
  remarks: 'หมายเหตุ',
  details: 'เปรียบเทียบก่อนและหลังการเปลี่ยนแปลง',
  revoke: 'ยกเลิกการขอ',
  return: 'ส่งคืน',
  judgeDuty: 'ตรวจสอบความรับผิดชอบ',
  businessAudit: 'ตรวจสอบทางธุรกิจ',
  judgeClosed: 'ตัดสินปิดบัญชี',
  exportDetail: 'ส่งออกรายละเอียด',
  tabJudgeDuty: 'รอตรวจสอบความรับผิดชอบ',
  tabBusinessAudit: 'รอตรวจสอบทางธุรกิจ',
  tabJudgeClosed: 'รอตัดสินปิดบัญชี',
  tabManagerReview: 'รอการตรวจสอบจากผู้จัดการ',
  tabAll: 'ทั้งหมด',
  dateCreatedDay: 'วันที่ขอ',
  judgeDutyDateDay: 'วันที่ตรวจสอบความรับผิดชอบ',
  businessAuditDateDay: 'วันที่ตรวจสอบทางธุรกิจ',
  judgeClosedDateDay: 'วันที่ตัดสินปิดบัญชี',
  applyChangeCharge: 'ขอเปลี่ยนแปลงค่าใช้จ่าย',
  applyAddCharge: 'ขอเพิ่มค่าใช้จ่าย',
  applyDeleteCharge: 'ขอลบค่าใช้จ่าย',
  showApplyChangingCharge: 'ดูการตรวจสอบการเปลี่ยนแปลงค่าใช้จ่าย',
  ChangeTheChargesInTheExpenseReview: 'ค่าใช้จ่ายในการตรวจสอบการเปลี่ยนแปลง',
  actionType: 'ประเภทการขอ',
  confirmApplyDeleteCharge: 'ยืนยันการขอลบค่าใช้จ่ายนี้หรือไม่?',
  changeReasonCannotBeNull: 'เหตุผลการเปลี่ยนแปลงไม่สามารถเว้นว่างได้',
  changeReasonIsTooLong: 'ความยาวเหตุผลการเปลี่ยนแปลงไม่เกิน 100',
  judgeDutyMessage: 'ผู้ปฏิบัติงานในการเปลี่ยนแปลงค่าใช้จ่ายครั้งนี้มีความรับผิดชอบหรือไม่?',
  judgeDutyYes: 'มีความรับผิดชอบ',
  judgeDutyNo: 'ไม่มีความรับผิดชอบ',
  businessAuditMessage: 'ยินยอมให้เปลี่ยนแปลงค่าธรรมเนียมหรือไม่?',
  businessAuditAgree: 'ยินยอม',
  businessAuditRefuse: 'ปฏิเสธ',
  businessAuditReasonNotNull: 'กรุณากรอกเหตุผลในการปฏิเสธ',
  judgeClosedMessage: 'การเปลี่ยนแปลงค่าธรรมเนียมครั้งนี้เป็นก่อนปิดบัญชีหรือหลังปิดบัญชี?',
  judgeClosedBefore: 'ก่อนปิดบัญชี',
  judgeClosedAfter: 'หลังปิดบัญชี',
  returnMessage: 'คำขอนี้จะกลับสู่สถานะเริ่มต้น',
  returnMessageConfirm: 'ยืนยันการส่งคืนหรือไม่?',
  returnReasonNotNull: 'กรุณากรอกเหตุผลในการส่งคืน',
  revokeMessage: 'สามารถยกเลิกเฉพาะคำขอที่ยังไม่ได้รับการอนุมัติเท่านั้น โปรดตรวจสอบ',
  revokeMessageConfirm: 'หลังจากยกเลิกแล้วไม่สามารถกู้คืนได้ ยืนยันการยกเลิกหรือไม่?',
  modifyBefore: 'ก่อนแก้ไข',
  modifyAfter: 'หลังแก้ไข',
  estimateProfit: 'กำไรโดยประมาณทั้งใบ:',
  generateByContract: 'นำเข้าราคาประมาณ',
  generateByContractConfirm: 'ยืนยันการนำเข้าราคาประมาณหรือไม่?',
  JudgmentResult: 'ผลการตัดสินความรับผิดชอบ',
  ChangeCharge: 'เปลี่ยนแปลงค่าธรรมเนียม',
  OnlyRejectedApplicationFormsCanBeCopied: 'สามารถคัดลอกเฉพาะคำขอที่ถูกปฏิเสธเท่านั้น',
  JudgeBeforeAndAfterAccountClosing: 'ตัดสินก่อนหรือหลังปิดบัญชี',
  FeesIncurred: 'การเกิดค่าธรรมเนียม',
  updateSuccess: '【{0}】อัปเดตอัตราแลกเปลี่ยนค่าธรรมเนียมที่ยังไม่ได้ดำเนินการสำเร็จ',
  exchangeRates: 'ช่วงอัตราแลกเปลี่ยนมีการเปลี่ยนแปลง ต้องการอัปเดตอัตราแลกเปลี่ยนค่าธรรมเนียมหรือไม่?',
  exchangeRates2: 'ช่วงอัตราแลกเปลี่ยนของตั๋วหลักมีการเปลี่ยนแปลง ต้องการอัปเดตอัตราแลกเปลี่ยนค่าธรรมเนียมภายใต้ตั๋วย่อยหรือไม่?',
  chargeLanguage: 'คำอธิบายภาษา',
  costDescription: 'คำอธิบายค่าธรรมเนียม'
}
